import PersonalizeRegistry from './personalize-registry'

export default PersonalizeRegistry
